import { useTranslation } from 'react-i18next'

import { Card } from '@/components/ui/card'
import { Flex } from '@/components/ui/flex'
import { Skeleton } from '@/components/ui/skeleton'
import { Typography } from '@/components/ui/typography'

import * as S from './keyless-access.styled'

export const KeylessAccessSkeleton = () => {
  const { t } = useTranslation(['clients'])

  return (
    <Card>
      <Flex justify="space-between" align="center">
        <Typography size="heading-small" as="h2">
          {t('clients:keylessAccess.title')}
        </Typography>
        <Skeleton variant="rectangular" width="5rem" height="3rem" />
      </Flex>
      <Flex gap={8} padding="12 16">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rectangular" width="10rem" height="3.2rem" />
        ))}
      </Flex>
      <S.TabContent>
        {[1, 2, 3].map((i) => (
          <S.FieldRow key={i}>
            <Flex gap={6} align="center">
              <Skeleton variant="text" width="12rem" height="1.4rem" />
            </Flex>
            <Skeleton variant="text" width="16rem" height="1.4rem" />
          </S.FieldRow>
        ))}
      </S.TabContent>
    </Card>
  )
}
